module.exports = __webpack_public_path__ + "static/media/development-portal.4b3ac8c9.png";